import { Directive, input } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';

import { FormsValidators } from '@shared/components/forms/validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[greaterThan]',

  providers: [{ provide: NG_VALIDATORS, useExisting: GreaterThanValidatorDirective, multi: true }],
})
export class GreaterThanValidatorDirective implements Validator {
  public readonly greaterThan = input<string | number | null | undefined>(undefined);

  public validate(c: UntypedFormControl) {
    if (this.greaterThan() === undefined || this.greaterThan() === null) {
      return null;
    }

    return FormsValidators.greaterThan(+(this.greaterThan() ?? 0))(c);
  }
}
